import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {TradeEntity} from '../Entities/TradeEntity.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */
export class ConfirmAgreedPriceTradeTransactionsUseCase extends UseCase {
  #httpTransactionsRepository

  constructor({httpTransactionsRepository}) {
    super()
    this.#httpTransactionsRepository = httpTransactionsRepository
  }

  static create({config}) {
    return new ConfirmAgreedPriceTradeTransactionsUseCase({
      httpTransactionsRepository: HTTPTransactionRepository.create({config})
    })
  }

  @inlineError
  async execute({agreedPrice, tradeId}) {
    const tradeEntity = TradeEntity.create({
      agreedPrice: Number(agreedPrice),
      id: tradeId
    })

    const [error] = await this.#httpTransactionsRepository.confirmAgreedPrice(tradeEntity)

    if (error) return Promise.reject(error)
  }
}

export const factory = ConfirmAgreedPriceTradeTransactionsUseCase.create
